import { UI } from '@Modules/UI';
import { appConfig as $config } from '@App/app.config';
import { suitabilityRender, pantoneNameRender, colorPalleteRender } from './utils';

const $filesModel = $config.filesModel;

export const TABLE_COLUMNS = {
  sourceFilesColumns: (printAreas) => {
    return [
      {
        data: null,
        width: 30,
        defaultContent: '',
        className: 'control',
        orderable: false,
        sortable: false,
        responsivePriority: 0
      },
      {
        title: '',
        data: 'thumbnail',
        width: 32,
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          return UI.thumbnail(data);
        }
      },
      {
        title: $lang.assetsManager.FileType,
        data: 'type',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          let description =
            full.additionalValues && full.additionalValues.description
              ? full.additionalValues.description
              : full.type != undefined && $filesModel[full.type].description
              ? $filesModel[full.type].description
              : false;
          let result =
            $filesModel[data].typeTitle + (description ? `<br><small class="text-muted">${description}</small>` : ``);
          return `<div data-aid="artwork-soruce-files-file-type">${result}</div>`;
        }
      },
      {
        title: $Lang.assetsManager.FileName,
        data: 'name',
        render: (data, type, full) => {
          return `<div data-aid="artwork-soruce-files-name">${data}</div>`;
        }
      },
      {
        title: $lang.assetsManager.Suitability,
        data: 'additionalValues',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          let result = suitabilityRender(full, printAreas);
          return `<div data-aid="artwork-soruce-files-suitability">${result}</div>`;
        }
      },
      {
        title: $lang.assetsManager.Size,
        data: 'additionalValues',
        className: 'text-nowrap',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          if (data.width && data.height)
            return `<div data-aid="artwork-soruce-files-size">${data.width} x ${data.height} px</div>`;
          else return '';
        }
      },
      {
        title: $lang.assetsManager.Resolution,
        data: 'additionalValues',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          let out = '';
          if (
            full.type == 1 &&
            data.width &&
            data.height &&
            printAreas.$printAreaFull &&
            printAreas.$printAreaFull.width &&
            printAreas.$printAreaFull.height
          ) {
            let fileDPI = Math.max(
              parseInt((data.width * 1) / printAreas.$printAreaFull.width),
              parseInt((data.height * 1) / printAreas.$printAreaFull.height)
            );
            out = fileDPI + ' DPI';
          }
          return `<div data-aid="artwork-soruce-files-resolution">${out}</div>`;
        }
      },
      {
        orderable: false,
        data: null,
        sortable: false,
        responsivePriority: 0,
        width: 30,
        render: (data, type, full) => {
          return (
            '<a href="javascript:" data-id="' +
            full.id +
            '" data-parttype="' +
            full.partType +
            '" class="js-action-RemoveAssetsFile btn btn-icon btn-sm btn-hover-danger bbw-border-radius"><i class="fal fa-trash-alt"></i></a>'
          );
        }
      }
    ];
  },

  screenPrintFilesColumns: ($infoMode) => {
    return [
      {
        data: null,
        width: 30,
        defaultContent: '',
        className: 'control',
        orderable: false,
        sortable: false,
        responsivePriority: 0
      },
      {
        data: null,
        width: 5,
        default: false,
        defaultContent: '<i class="fal fa-arrows-alt-v fa-lg"></i>',
        className: 'reorder-arrows c-pointer',
        orderable: false,
        sortable: false,
        searchable: false,
        responsivePriority: 1
      },
      { title: '#', data: 'order', className: 'd-none' },
      {
        title: $lang.assetsManager.NegativePrintingfile+'<sup><i class="fas fa-asterisk text-danger ml-1"></i></sup>',
        data: 'negativeFile',
        orderable: false,
        sortable: false,
        searchable: false,
        width: '20%',
        render: (data, type, full) => {
          return data.name
            ? `<div class="d-flex align-items-center">${UI.thumbnail(
                data.thumbnail
              )}<div class="pl-3" style="word-break:break-word;">${data.name}</div></div>`
            : ``;
        }
      },
      {
        title: $lang.assetsManager.ColoredPrintingfile,
        data: 'coloredFile',
        orderable: false,
        sortable: false,
        searchable: false,
        width: '20%',
        render: (data, type, full) => {
          return data.name
            ? `<div class="d-flex align-items-center">${UI.thumbnail(
                data.thumbnail
              )}<div class="pl-3" style="word-break:break-word;">${data.name}</div></div>`
            : ``;
        }
      },
      {
        title: $lang.assetsManager.Pantonename,
        data: 'pantoneName',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          return pantoneNameRender(data, type, full, $infoMode);
        }
      },
      {
        title: $lang.assetsManager.CMYK,
        data: 'colorPallete',
        width: 250,
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          return colorPalleteRender(data, type, full, $infoMode);
        }
      },
      {
        orderable: false,
        data: null,
        sortable: false,
        responsivePriority: 0,
        width: 30,
        render: (data, type, full) => {
          return (
            '<a href="javascript:" data-id="' +
            full.id +
            '" data-parttype="' +
            full.partType +
            '" class="js-action-RemoveAssetsFile btn btn-icon btn-sm btn-hover-danger bbw-border-radius"><i class="fal fa-trash-alt"></i></a>'
          );
        }
      }
    ];
  },

  AOPFilesColumns: () => {
    return [
      {
        data: null,
        width: 30,
        defaultContent: '',
        className: 'control',
        orderable: false,
        sortable: false,
        responsivePriority: 0
      },
      {
        title: '',
        data: 'thumbnail',
        width: 32,
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          return `<div class="thumbnail" data-width="${full.width}" data-height="${full.height}">
            ${data ? UI.thumbnail(data) : ''}
          </div>`;
        }
      },
      {
        title: $lang.assetsManager.Resolution,
        data: 'resolution',
        orderable: false,
        sortable: false,
        searchable: false,
      },
      {
        title: $lang.assetsManager.TemplateName,
        data: 'templateName',
        orderable: false,
        sortable: false,
        searchable: false,
      },
      {
        title: $lang.assetsManager.AopTransform,
        data: 'aopTransform',
        orderable: false,
        sortable: false,
        searchable: false,
        responsivePriority: 3,
        render: aopTransformRender
      },
      {
        orderable: false,
        data: null,
        sortable: false,
        responsivePriority: 3,
        render: (data, type, full) => {
          return `
            <button type="button" class="js-action-aop-generate-btn btn btn-outline-primary" style="font-weight: unset;"
            data-width="${full.width}" data-height="${full.height}">
              ${$lang.assetsManager.Generate}
            </button>
          `;
        }
      },
      {
        orderable: false,
        data: null,
        sortable: false,
        responsivePriority: 3,
        render: (data, type, full) => {
          return `
            <a href="javascript:" class="link-with-icon js-action-replace-aop-file-btn"
               data-width="${full.width}" data-height="${full.height}">
              <i class="fal fa-plus-square"></i>${$lang.assetsManager.artwork.ReplaceFile}
            </a>
          `;
        }
      }
    ];
  },

  trimColumns: (printAreas) => {
    return [
      {
        data: null,
        width: 30,
        defaultContent: '',
        className: 'control',
        orderable: false,
        sortable: false,
        responsivePriority: 0
      },
      {
        title: $lang.assetsManager.FileType,
        data: 'type',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          let description =
            full.additionalValues && full.additionalValues.description
              ? full.additionalValues.description
              : full.type != undefined && $filesModel[full.type].description
              ? $filesModel[full.type].description
              : false;
          return (
            $filesModel[data].typeTitle + (description ? `<br><small class="text-muted">${description}</small>` : ``)
          );
        }
      },
      { title: $lang.assetsManager.FileName, data: 'name', orderable: false, sortable: false, searchable: false },
      {
        title: $lang.assetsManager.TrimSize,
        data: 'additionalValues',
        className: 'text-nowrap',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          if (data.width && data.height) return `${data.width} x ${data.height} px`;
          else return '';
        }
      },
      {
        title: $lang.assetsManager.FileResolution,
        data: 'additionalValues',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          let out = '';
          if (full.type == 1 && data.width && printAreas.$printAreaFull && printAreas.$printAreaFull.width) {
            out = parseInt(((data.width * 1) / printAreas.$printAreaFull.width) * 1) + ' DPI';
          }
          return out;
        }
      },
      {
        title: $lang.assetsManager.Thumbnail,
        data: 'thumbnail',
        width: 32,
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          return UI.thumbnail(data);
        }
      },
      {
        orderable: false,
        data: null,
        sortable: false,
        responsivePriority: 0,
        width: 30,
        render: (data, type, full) => {
          return (
            '<a href="javascript:" data-id="' +
            full.id +
            '" data-parttype="' +
            full.partType +
            '" class="js-action-RemoveAssetsFile btn btn-icon btn-sm btn-hover-danger bbw-border-radius"><i class="fal fa-trash-alt"></i></a>'
          );
        }
      }
    ];
  },

  stampColumns: (printAreas) => {
    return [
      {
        data: null,
        width: 30,
        defaultContent: '',
        className: 'control',
        orderable: false,
        sortable: false,
        responsivePriority: 0
      },
      {
        title: $lang.assetsManager.FileType,
        data: 'type',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          let description =
            full.additionalValues && full.additionalValues.description
              ? full.additionalValues.description
              : full.type != undefined && $filesModel[full.type].description
              ? $filesModel[full.type].description
              : false;
          return (
            $filesModel[data].typeTitle + (description ? `<br><small class="text-muted">${description}</small>` : ``)
          );
        }
      },
      { title: $lang.assetsManager.FileName, data: 'name', orderable: false, sortable: false, searchable: false },
      {
        title: $lang.assetsManager.Size,
        data: 'additionalValues',
        className: 'text-nowrap',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          if (data.width && data.height) return `${data.width} x ${data.height} px`;
          else return '';
        }
      },
      {
        title: $lang.assetsManager.FileResolution,
        data: 'additionalValues',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          let out = '';
          if (full.type == 1 && data.width && printAreas.$printAreaFull && printAreas.$printAreaFull.width) {
            out = parseInt((data.width * 1) / printAreas.$printAreaFull.width) + ' DPI';
          }
          return out;
        }
      },
      {
        title: $lang.assetsManager.Thumbnail,
        data: 'thumbnail',
        width: 32,
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          return UI.thumbnail(data);
        }
      },
      {
        orderable: false,
        data: null,
        sortable: false,
        responsivePriority: 0,
        width: 30,
        render: (data, type, full) => {
          return (
            '<a href="javascript:" data-id="' +
            full.id +
            '" data-parttype="' +
            full.partType +
            '" class="js-action-RemoveAssetsFile btn btn-icon btn-sm btn-hover-danger bbw-border-radius"><i class="fal fa-trash-alt"></i></a>'
          );
        }
      }
    ];
  }
};

const aopTransformRender = (data) => {
  return `
    <select class="form-control js-action-aop-transform-select" style="max-width: 180px;">
      ${Object.values($config.aopTransform).map((aopt) => `<option ${data === aopt.value ? 'selected' : ''} value="${aopt.value}">${aopt.name}</option>`)}
    </select>
  `;
};
